import { createVuetify } from 'vuetify'
import * as components from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          hnet: '#cd3c1d'
        }
      },
      light: {
        colors: {
          hnet: '#cd3c1d'
        }
      }
    }
  },
  defaults: {
    global: {
      // Globale Schriftart-Einstellungen
      font: {
        family: 'Aldrich, Arial Black, Helvetica, sans-serif',
      }
    },
  },
})